import downloadJobSheet from '../Services/downloadJobSheet';
import fetchProject from '../Services/fetchProject';

export default () => async (dispatch) => {

  dispatch(downloadJobSheet());

  dispatch(fetchProject());
}
